import React from 'react';

const ReviewName = ({ name }) => {
  const nameSplit = (name || '').trim().split(' ');
  const nameFirst = nameSplit[0];
  let nameLast = '';
  if(nameSplit.length > 1){
    nameLast = ` ${nameSplit[nameSplit.length - 1].substr(0,1)}.`;
  }
  return <span>{`${nameFirst}${nameLast}`}</span>;
};

export default ReviewName;
